var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "mainContent startContactDiv" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "mainContent__inputs" }, [
          _c(
            "div",
            { staticClass: "mainContent__inputs__fullname" },
            [
              _vm._m(1),
              _vm._v(" "),
              _c("sc-input", {
                model: {
                  value: _vm.fullname,
                  callback: function($$v) {
                    _vm.fullname = $$v
                  },
                  expression: "fullname"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mainContent__inputs__email" },
            [
              _vm._m(2),
              _vm._v(" "),
              _c(
                "sc-field",
                {
                  attrs: {
                    message: _vm.emailValidationMessage(),
                    type: _vm.emailValidationMessage() ? "is-danger" : ""
                  }
                },
                [
                  _c("sc-input", {
                    on: {
                      input: function($event) {
                        _vm.onChangeEmail()
                      }
                    },
                    model: {
                      value: _vm.email,
                      callback: function($$v) {
                        _vm.email = $$v
                      },
                      expression: "email"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mainContent__inputs__phone" },
            [
              _vm._m(3),
              _vm._v(" "),
              _c("sc-input", {
                directives: [
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: "(##) #####-####",
                    expression: "'(##) #####-####'"
                  }
                ],
                attrs: { type: "phone" },
                model: {
                  value: _vm.phone,
                  callback: function($$v) {
                    _vm.phone = $$v
                  },
                  expression: "phone"
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("help-button")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mainContent__paragraphs" }, [
      _c("p", [
        _vm._v(
          "\n        Informe seu(s) o(s) contato(s) na transportadora, geralmente é o responsável pela sua conta ou comercial da transportadora.\n      "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        Esse contato vai receber os dados para configurar a integração com a Intelipost.\n      "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "fullname" } }, [
      _c("strong", [_vm._v("Nome Completo:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "email" } }, [
      _c("strong", [_vm._v("Email  de contato na transportadora:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "phone" } }, [
      _c("strong", [_vm._v("Telefone:")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c3f9bff6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3f9bff6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/ScContact.vue
// module id = null
// module chunks = 